export const myDocumentsSettingsPageMenuDef = [
  {
    id: "myDocumentsGeneralSettings",
    label: "OC_GENERAL_SETTINGS",
    roles: ["MyHR.admin"],
  },
];
